import { Helmet } from 'react-helmet-async';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
        />
      </Helmet>
      <footer className="bg-gray-900 text-white py-6 px-4 mt-auto">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm md:text-base">
            &copy; {currentYear} Scotts Olde Tyme Power and Equipment Association
          </p>
          <div className="flex gap-4">
            <a
              href="https://www.facebook.com/profile.php?id=100080336617870"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="text-2xl hover:text-primary-green transition-colors"
            >
              <i className="fab fa-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/scottstractorshow"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-2xl hover:text-primary-green transition-colors"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;



